var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ArrayMinSize, IsArray, IsOptional, IsUUID } from 'class-validator';
/**
 * Body for `POST /appointments/confirm-booking-batch` (PRD #1343, RS-004). The
 * practice confirms a whole booking pass in one atomic action from the inbox:
 * every id must be a pending hold the caller may update, and all flip to
 * CONFIRMED in a single transaction (or none do). The inbox knows the pass's
 * member ids from the grouped `bookingPassId`.
 */
export class ConfirmBookingBatchDto {
    appointmentIds;
    /**
     * Reassign the whole pass to this therapist at confirm (PRD #1343, RS-007) —
     * used when the patient chose "egal". Applied to every hold in the pass in the
     * same transaction; omitted keeps each hold's auto-preselected therapist.
     */
    assignTherapistId;
}
__decorate([
    IsArray(),
    ArrayMinSize(1),
    IsUUID('4', { each: true }),
    __metadata("design:type", Array)
], ConfirmBookingBatchDto.prototype, "appointmentIds", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], ConfirmBookingBatchDto.prototype, "assignTherapistId", void 0);
//# sourceMappingURL=confirm-booking-batch.dto.js.map